import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeErrorReporting } from './utils/errorReporting';

// Initialize global error handlers for automatic error reporting
initializeErrorReporting();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker registration is now handled by DryPWA via DryContext.
// See src/dry/pwa.ts — registerSW() is called during DryProvider init.
